<template>
	<div class="d-flex align-center">
		<v-btn
			class="mx-2"
			rounded
			color="white"
			raised
			v-if="!readOnly && checkApprovalChecks && checkPermissions(['end_rdi'])"
			@click="startCloseRDI"
		>
			<p class="mb-0 text-primary">Finalizar RDI</p>
		</v-btn>
		<div>
			<ApprovalChecks
				:item="rdi"
				item_type="rdi"
				:roles_needed="requiredRoles"
				:read_only="readOnly"
				v-if="rdi && rdiAprovalCheck"
				@onChange="reloadInfo"/>
		</div>
	</div>
</template>

<script>
import ApprovalChecks from '@/components/Globals/Helpers/ApprovalChecks'

export default {
	name: 'RdiClosure',
	components: {
		ApprovalChecks
	},
	props: {
		rdi: {
			type: Object,
			required: true
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		availableProfiles() {
			const creator = { id: -1, name: 'Creador',       description: 'Creador del ítem' }
			return [creator, ...this.$store.projectsStore.state.projectProfiles]
		},
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
		rdiAprovalCheck() {
			return this.selectedProject?.closure_config?.find(config => config.item_type === 1 && config.use_advanced_closure)
		},
		requiredRoles() {
			return this.rdiAprovalCheck ? this.rdiAprovalCheck.advanced_closure_profiles : []
		},
		approvalChecks(){
			return this.rdi.approval_checks
		},
		checkApprovalChecks(){
			if(!this.rdiAprovalCheck) return true
			
			const createdBy = this.rdi.created_by

			return this.requiredRoles.every(roleId => {
				if (roleId === -1) {
					return this.approvalChecks.some(item => item.user_id === createdBy)
				}
				return this.approvalChecks.some(item => item.job_type === roleId)
			})
		}
	},
	mounted() {
	},
	methods: {
		startCloseRDI() {
			this.$emit('startCloseRDI')
		},
		reloadInfo() {
			this.$emit('reloadInfo')
		}
	}
}
</script>

<style>

</style>